<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'modals.add_ingredient' | translate }}
    v-card-content
      v-select.mb-3(
        label="base.type"
        api-search
        :options="ingredientTypes"
        v-model="ingredient_type"
        @input="onTypeChange"
        @search="onIngredientTypeSearch")
      v-input.mb-3(
        v-if="ingredient_type"
        :label="$t('base.name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        v-model="name")
      v-select.mb-3(
        :label="$t('base.stock')"
        :options="filteredStocks"
        v-model="stock")
      .toogle-wrap
        ui-toggle-unit(
          :tolerancePercent="tolerance_percent"
          :toleranceUnit="tolerance_unit"
          :toleranceKg="tolerance_kg"
          @update="onToleranceUpdate"
        )
      v-input.mb-3.mt-5(
        :label="$t('base.dry_metter')"
        :hint="errorMessage('dry_matter')"
        :invalid="!!errorMessage('dry_matter')"
        :float="true"
        type="text"
        pattern="^[0-9]+([.,][0-9]{0,2})?$"
        min="0"
        max="100"
        v-model="dry_matter")
      v-switch.mb-3(
        :label="$t('history.ignore_in_reports')"
        v-model="ignored_in_report")
      v-switch(
        :label="$t('history.autoload')"
        v-model="auto_load")
    v-card-actions
      v-btn.mr-2(
        :loading="loading"
        :disabled="!isValid"
        @click="onCreateIngredient")
        | {{ 'base.add' | translate }}
</template>

<script>
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
import UiToggleUnit from '@/components/ui/ui-toggle-unit/UiToggleUnit.vue'
export default {
  name: 'CreateModal',
  components: {
    UiToggleUnit
  },
  mixins: [formErrorsMixin],

  data: () => ({
    name: null,
    tolerance_kg: 0,
    tolerance_percent: 97,
    tolerance_unit: 'percent',
    ignored_in_report: false,
    ingredient_type: null,
    stock: null,
    dry_matter: 0,
    auto_load: false,
    loading: false,
    errors: {
      name: null
    },
    ingredientTypes: []
  }),

  mounted () {
    this.onIngredientTypeSearch()
    const company = +this.$route.params.company_id
    const farm = +this.$route.params.farm_id
    this.loadStocks({ company, farm })
  },

  computed: {
    ...mapGetters('stocks', [
      'stocks'
    ]),

    filteredStocks () {
      return this.stocks
    },

    isValid () {
      return !!(this.name &&
        this.stock &&
        this.ingredient_type)
    }
  },

  methods: {
    ...mapActions('stocks', [
      'loadStocks'
    ]),

    onTypeChange (id) {
      const ingredientType = this.ingredientTypes
        .find(item => item.id === id)
      if (ingredientType) {
        this.name = ingredientType.name
      }
    },

    async onIngredientTypeSearch (value = null) {
      const params = {
        name: value,
        limit: 20000
      }
      const { data } = await api.ingredienttypes.litelist(params)
      this.ingredientTypes = data
    },

    async onCreateIngredient () {
      this.loading = true
      // Check if dry_matter exists and has a comma
      if (this.dry_matter && this.dry_matter.includes(',')) {
        this.dry_matter = this.dry_matter.toString().replace(',', '.')
      }
      const payload = {
        name: this.name,
        farm: +this.$route.params.farm_id,
        dry_matter: +this.dry_matter,
        ignored_in_report: this.ignored_in_report,
        stock: { id: this.stock },
        ingredient_type: { id: this.ingredient_type },
        auto_load: this.auto_load,
        tolerance_kg: this.tolerance_kg,
        tolerance_percent: this.tolerance_percent,
        tolerance_unit: this.tolerance_unit,
      }

      this.checkValidData()

      if (this.errors.name === null) {
        const { errors } = await api.ingredients.create(payload)
        this.errors = errors
        if (errors) {
          if (errors.non_field_errors && errors.non_field_errors[0] === '5') {
            this.$toasted.error(this.$t('errors.incorrect_ingredient_type'))
          }
        } else {
          this.$emit('update', this.stock)
          this.$emit('close')
        }
      }
      this.loading = false
    },
    checkValidData () {
      this.errors.name = null
      if (!this.name) {
        this.errors.name = this.errors.name = ['3']
      } else if (this.name.length > 100) {
        this.errors.name = this.errors.name = ['6', 100]
      }
    },
    onToleranceUpdate (payload) {
      this.tolerance_kg = payload.tolerance_kg
      this.tolerance_percent = payload.tolerance_percent
      this.tolerance_unit = payload.tolerance_unit
    }
  }
}
</script>
